import { render } from "./BotaoRoteiro.vue?vue&type=template&id=b734a4d6&scoped=true"
import script from "./BotaoRoteiro.vue?vue&type=script&lang=js"
export * from "./BotaoRoteiro.vue?vue&type=script&lang=js"

import "./BotaoRoteiro.vue?vue&type=style&index=0&id=b734a4d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b734a4d6"]])

export default __exports__